<template lang="pug">
  #eventActivitySuccess.d-flex.flex-column(
    style="height: calc(100% - 120px)"
  )
    .container-width.text-center.w-100(
      style="flex: 1 1 0;"
    )
      form(ref="form" id='newebpay' name='newebpay' method="post" :action="URL" :class="{ 'd-none': !showForm}" style='opacity: 0')
        input(type='text' v-model='MerchantID' name='MerchantID')
        input(type='text' v-model='TradeInfo' name='TradeInfo')
        input(type='text' v-model='TradeSha' name='TradeSha')
        input(type='text' v-model='Version' name='Version')
</template>

<script>
import { mapState } from 'vuex';
const moment = require('moment');

export default {
  name: 'reservationPayment',
  props: {
    paymentInfo: {
      type: Object,
      default: null,
    },
    activityId: {
      type: [String, Number,],
      default: null,
    }
  },
  data() {
    return {
      MerchantID: '',
      TradeInfo: '',
      TradeSha: '',
      URL: '',
      Version: '',
      showForm: false
    };
  },
  created() {
    const vm = this;
    vm.$store.commit('toggleLoading', false);
    if (vm.paymentInfo) {
      vm.$set(vm, 'MerchantID', vm.paymentInfo.MerchantID);
      vm.$set(vm, 'TradeInfo', vm.paymentInfo.TradeInfo);
      vm.$set(vm, 'TradeSha', vm.paymentInfo.TradeSha);
      vm.$set(vm, 'URL', vm.paymentInfo.URL);
      vm.$set(vm, 'Version', vm.paymentInfo.Version);
      vm.showForm = true;
      setTimeout(() => {
        vm.$refs.form.submit();
      }, 50);
    } else {
      vm.$swal.fire({
        icon: 'error',
        title: '參數錯誤',
        confirmButtonText: '回官方帳號'
      }).then(() => {
        vm.backToLINEHandler();
      });
    }

  },
  methods: {
    moment(val) {
      return moment(val);
    },
    backToLINEHandler() {
      window.location = process.env.VUE_APP_LINE_ADD_FRIEND_LINK;
    }
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.member_event_activity.userInfo
    })
  }
};
</script>

<style lang="scss" scoped>
.grayArea {
  background-color: #F0F0F0;
}
</style>
